import { __extends } from "tslib";
import { getShadowElement, Platform, removeAllChildren } from '@tyler-components-web/core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { AVATAR_CONSTANTS } from './avatar-constants';
/**
 * The DOM adapter behind the `<tcw-avatar>` element.
 */
var AvatarAdapter = /** @class */ (function (_super) {
    __extends(AvatarAdapter, _super);
    function AvatarAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._root = getShadowElement(_this._component, AVATAR_CONSTANTS.selectors.ROOT);
        _this._defaultSlot = getShadowElement(_this._component, AVATAR_CONSTANTS.selectors.DEFAULT_SLOT);
        return _this;
    }
    /**
     * Sets the `backgroundColor` style on the content element.
     * @param {string} value The background color.
     */
    AvatarAdapter.prototype.setBackgroundColor = function (value) {
        if (Platform.TRIDENT) {
            this._root.style.backgroundColor = value;
        }
        else {
            this._root.style.backgroundColor = "var(--tyl-avatar-background-color, " + value + ")";
        }
    };
    /**
     * Sets the background image URL.
     * @param url The URL.
     */
    AvatarAdapter.prototype.setBackgroundImageUrl = function (url) {
        var _this = this;
        var backgroundColor = this._root.style.backgroundColor;
        // doing his before the promise so it doesn't flash a color before loading
        this._root.style.backgroundColor = 'inherit';
        var loadResult = new Promise(function (resolve) {
            var image = new Image();
            image.onload = function () {
                _this._root.style.backgroundImage = "url(" + image.src + ")";
                resolve(true);
            };
            image.onerror = function () {
                _this._root.style.backgroundColor = backgroundColor;
                resolve(false);
            };
            image.src = url;
        });
        return loadResult;
    };
    /**
     * Removes the background image URL.
     */
    AvatarAdapter.prototype.removeBackgroundImage = function () {
        this._root.style.removeProperty('background-image');
    };
    /**
     * Sets the avatar text content.
     * @param value The text value.
     */
    AvatarAdapter.prototype.setText = function (value) {
        this._defaultSlot.textContent = value;
    };
    AvatarAdapter.prototype.clearText = function () {
        removeAllChildren(this._defaultSlot);
    };
    return AvatarAdapter;
}(BaseAdapter));
export { AvatarAdapter };
